export interface Permission {
  id: string;
  name: string;
  assignable_by_tenant: boolean;
  module_id: string;
}
